module.exports = __webpack_public_path__ + "img/55800.b38da968.jpg";